import { DocViewerRenderers, PDFRenderer, JPGRenderer, PNGRenderer, GIFRenderer, WebPRenderer, CSVRenderer, MSDocRenderer } from '@cyntler/react-doc-viewer';

/** The extension a document's name ends in, lowercased, or undefined when it has none. */
export const getFileTypeFromName = docName => {
  var _docName$split$pop;
  return docName === null || docName === void 0 || (_docName$split$pop = docName.split('.').pop()) === null || _docName$split$pop === void 0 ? void 0 : _docName$split$pop.toLowerCase();
};

/**
 * Which renderers to hand the viewer for a file, chosen by the name it was stored under.
 *
 * One renderer where the name says what the file is, so the viewer has nothing to work out. The
 * whole set where it does not — a file with no extension, or a name we have never seen — because
 * naming a single wrong renderer is worse than naming none: it cannot report holding the wrong sort
 * of file, and simply shows a spinner that never stops (LB-5897).
 *
 * `gif` and `webp` are here because the upload queue accepts them: ACCEPTED_BILL_FILE_TYPES is
 * `.pdf,.png,.jpg,.jpeg,.gif,.webp`, and a person who uploads a format the product took should not
 * then be told there is no renderer for it.
 */
export const getRenderersForFileName = docName => {
  switch (getFileTypeFromName(docName)) {
    case 'doc':
    case 'docx':
      return [MSDocRenderer];
    case 'csv':
      return [CSVRenderer];
    case 'png':
      return [PNGRenderer];
    case 'jpg':
    case 'jpeg':
      return [JPGRenderer];
    case 'gif':
      return [GIFRenderer];
    case 'webp':
      return [WebPRenderer];
    case 'pdf':
      return [PDFRenderer];
    default:
      return DocViewerRenderers;
  }
};